import { MenuItem } from 'primeng/api';
import { ColumnTypeEnum } from '../base-column/column-type-enum';
import { ColumnConfig } from '../base-column/column.model';
import {
  initFromConfigButton,
  initFromPropsButtons,
} from '../common-models/init-functions';
import { styleProperties } from '../common-models/style.model';
import { ButtonColumn } from './button-column.model';
import { EoButtonMenuItem } from './common/button-menu-item.model';

export interface MenuButtonColumnConfig<T> extends ColumnConfig<T> {
  menuItems: EoButtonMenuItem<T>[];
}

export class MenuButtonColumn<T> extends ButtonColumn<T> {
  menuItems: EoButtonMenuItem<T>[];

  constructor(config: MenuButtonColumnConfig<T>);
  constructor(
    title?: string,
    icon?: string | ((item?: any) => string),
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties,
    pTooltip?: string | ((item?: any) => string),
    tooltipPosition?: string,
    action?: (item?: T, event?: any) => any,
    isVisibleAction?: (item?: T) => boolean,
    isDisabledAction?: (item?: T) => boolean
  );
  constructor(
    titleOrConfig?: MenuButtonColumnConfig<T> | string,
    icon?: string | ((item?: any) => string),
    styleClass?: string | ((item?: any) => string),
    style?: styleProperties,
    pTooltip?: string | ((item?: any) => string),
    tooltipPosition?: string,
    action?: (item?: T, event?: any) => any,
    isVisibleAction?: (item?: T) => boolean,
    isDisabledAction?: (item?: T) => boolean,
    menuItems?: EoButtonMenuItem<T>[]
  ) {
    super();
    if (typeof titleOrConfig === 'object') {
      const config = titleOrConfig as MenuButtonColumnConfig<T>;
      initFromConfigButton(this, config);
      this.menuItems = config.menuItems ?? [];
    } else {
      initFromPropsButtons(
        this,
        titleOrConfig,
        icon,
        styleClass,
        style,
        pTooltip,
        tooltipPosition,
        action,
        isVisibleAction,
        isDisabledAction
      );
      this.menuItems = menuItems ?? [];
    }
  }

  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  override GetColumnType(): string {
    return ColumnTypeEnum.MenuButtonColumn;
  }

  getPMenuItems(row: T): MenuItem[] {
    return this.menuItems.map((item) => ({
      ...item,
      command: item.action.bind(this, row),
      visible:
        typeof item.isVisible === 'function'
          ? item.isVisible.bind(this, row)()
          : item.isVisible ?? true,
    }));
  }
}
